/**
 * Modal for fetching all Tank Cleanings. Avaible from the sub menu.
 */

var VRC = VRC || {};

VRC.TankCleanModal = (function(){
  var $el;

  var _template = WELL.Handlebars.VRC.tankclean_modal;
  var _loadingTemplate = WELL.Handlebars.VRC.progress_modal;
  var _title = 'Tank Cleanings';

  var fetchData = function(fromDate, toDate){
    return VRC.CommunicationService.fetchData({}, 'get_tank_cleanings', {version :  GetVersionNumber(), fromDate : fromDate, toDate : toDate})
  };

  var showLoading = function(){
    var $content = $el.find('.modal-content');
    $content.html(_loadingTemplate({ title : _title}));
  };

  var showMsg = function(errorMsg, type){
    var $alert = $el.find('.alert');
    $alert.addClass(type);
    $alert.text(errorMsg);
    $alert.removeClass('hidden');
  };

  var showTankCleanings = function (tankCleanings, fromDate, toDate) {
    var $content = $el.find('.modal-content');
    if (tankCleanings.length > 0) {

      _.map(tankCleanings, function (tankClean) {
        var port = VRC.MasterDataService.getPort(tankClean.originId);
        var cleanType = VRC.MasterDataService.getBulkCleanType(tankClean.actionObject);
        if (port) {
          tankClean.originName = port.name;
        }
        if (cleanType) {
          tankClean.cleanTypeName = cleanType.name;
        }

      });

      var bulkTanks = _.groupBy(tankCleanings, function (bulkTank) {
        return bulkTank.tankName + " - " + bulkTank.tankType;
      });
    }

    var context = {
      title: _title,
      bulkTanks: bulkTanks,
      fromDate: fromDate,
      toDate: toDate
    };

    $content.html(_template(context));
    if (tankCleanings.length === 0) {
      showMsg('There are no submitted tank cleanings between ' +fromDate+ ' and ' + toDate, 'alert-info');
    }
  };

  var render = function (fromDate, toDate) {
    showLoading();

    var fromDate = fromDate || moment().subtract(2, 'months').format(g_timeStampFormat);
    var toDate = toDate || moment().format(g_timeStampFormat);

    var getTankCleanings = fetchData(fromDate, toDate);

    getTankCleanings.done(function (object, tankCleanings) {
      showTankCleanings(tankCleanings, fromDate, toDate);
      attachEvents();
    });

    getTankCleanings.fail(function (msg) {
      showMsg(msg, 'alert-danger');
    });
  };

  var open = function(){
    $el = $('#bulk_modal');
    render();
    $el.modal('show', {backdrop: 'static'});

  };

  var attachEvents = function(){
    $el.find('.tankclean-modal__fetch-btn').click(function(){
      var fromDate = $el.find('.tankclean-modal__from-date').val();
      var toDate = $el.find('.tankclean-modal__to-date').val();

      if(fromDate && toDate){
        render(fromDate, toDate);
      }
    });
  };

  return {
    render : open
  }
})();